/* Bagsandlove – Kundenstimmen wechseln automatisch; Tippen springt zur nächsten */
if (!customElements.get('bl-review-ticker')) {
  customElements.define(
    'bl-review-ticker',
    class BlReviewTicker extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.bl-rt__item')];
        if (this.items.length < 2) return;
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 4500;

        this.addEventListener('click', () => {
          this.next();
          this.restart();
        });
        // Nicht wechseln, während jemand mit der Maus darauf zeigt
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        // Erst starten, wenn sichtbar – spart Arbeit und alle sehen das erste Zitat
        this.observer = new IntersectionObserver(([entry]) => (entry.isIntersecting ? this.restart() : this.stop()));
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
      }

      next() {
        const current = this.items[this.index];
        this.index = (this.index + 1) % this.items.length;
        const upcoming = this.items[this.index];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        setTimeout(() => current.classList.remove('is-leaving'), 450);

        upcoming.classList.add('is-active');
        upcoming.removeAttribute('aria-hidden');
      }

      restart() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
  );
}
